import React, { useRef } from 'react';
import { useElementWidth } from 'hooks/use-element-size';

interface Props {
  livestream_time: string;
  livestream_link: null | string;
  locale: 'en' | 'sv';
  placeholder_image: string;
}

const Livestream = (props: Props): React.ReactElement => {
  const { locale } = props;
  const rootRef = useRef<HTMLDivElement | null>(null);
  const width = useElementWidth(rootRef);
  const height = width / (16 / 9);

  return (
    <>
      <div className="livestream" ref={rootRef}>
        <div
          onClick={() =>
            window.location.assign(
              'https://www.youtube.com/watch?v=1ZpguEtL2fA&t=793',
            )
          }
          style={{
            cursor: 'pointer',
          }}
        >
          <iframe
            title="Livestream"
            src={'https://www.youtube.com/embed/1ZpguEtL2fA?t=793'}
            style={{
              width: '100%',
              height,
              pointerEvents: 'none',
              cursor: 'pointer',
            }}
            scrolling="no"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
        <div className="block">{translations.postStreamMessage[locale]}</div>
      </div>
    </>
  );
};

const translations = {
  postStreamMessage: {
    sv: 'Livesändningen är över, men du kan se den igen ovan!',
    en: 'The livestream is over, but you can watch it again above!',
  },
};

export default Livestream;
